module.exports = __webpack_public_path__ + "static/media/circle-hand-drawn.2eb44ed9.png";